<template>
  <div class="myIpadStock">
    <van-tabs v-model="activeName">
      <van-tab title="待盘点" name="待盘点"></van-tab>
      <van-tab title="已盘点" name="已盘点"></van-tab>
    </van-tabs>

    <div class="list-page">
      <form action="/">
        <van-search v-model="searchKey" placeholder="请输入搜索关键词" show-action shape="round" @search="onSearch"
          @cancel="onSearchCancel" />
      </form>

      <van-pull-refresh v-model="refreshing" @refresh="onLoad">
        <div style="min-height: 90vh">
          <div class="item" v-for="item in showList" :key="item.id">
            <van-panel :title="item.model || 'iPad'" :desc="'序列号: ' + item.serial" :status="item.Status">
              <div>
                <van-cell title="BU" :value="item.bu" :border="false" size="small" />
                <van-cell title="部门" :value="item.dept" :border="false" size="small" />
                <van-cell title="姓名" :value="item.chinese_name" :border="false" size="small" />
                <van-cell title="电话" :value="item.phone" :border="false" size="small" />
                <van-cell title="邮箱" :value="item.email" :border="false" size="small" />
                <van-cell title="实际使用人" :value="item.sj_user" :border="false" size="small" />
              </div>
              <div slot="footer" class="item_footer">
                <van-button v-if="item.stock_status == '待盘点'" type="primary" size="small" round
                  @click="gotoStock(item.id)">{{ "盘点" }}
                </van-button>
                <van-button v-if="item.stock_status == '已盘点'" type="primary" size="small" round
                  @click="gotoStock(item.id)">{{ "已盘点" }}
                </van-button>
                <van-button type="primary" size="small" round class="stock-btn" @click="showItemDetail(item)">
                  {{ "详情" }}
                </van-button>
              </div>
            </van-panel>
          </div>

          <van-popup v-model="showDetails" @close="closeDetails" position="right" class="detail-container" lock-scroll>
            <van-cell title="iPad资产详情" title-class="detail-title" size="large" />
            <van-cell title="iPad序列号" :value="listItem.serial" :border="false" class="detail-item" size="small" />
            <van-cell title="iPad型号" :value="listItem.model" :border="false" class="detail-item" size="small" />
            <van-cell title="资产状态" :value="listItem.Status" :border="false" class="detail-item" size="small" />
            <van-cell title="BU" :value="listItem.bu" :border="false" class="detail-item" size="small" />
            <van-cell title="部门" :value="listItem.dept" :border="false" class="detail-item" size="small" />
            <van-cell title="城市" :value="listItem.city" :border="false" class="detail-item" size="small" />
            <van-cell title="姓名" :value="listItem.chinese_name" :border="false" class="detail-item" size="small" />
            <van-cell title="电话" :value="listItem.phone" :border="false" class="detail-item" size="small" />
            <van-cell title="达能邮箱" :value="listItem.email" :border="false" class="detail-item" size="small" />
            <van-cell title="实际使用人" :value="listItem.sj_user" :border="false" class="detail-item" size="small" />
          </van-popup>

        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { Tab, Tabs, Search, PullRefresh, Dialog, Panel, CellGroup, Cell, Button, Popup, Icon, Toast } from "vant";

export default {
  components: {
    [Tab.name]: Tab, [Tabs.name]: Tabs, [Search.name]: Search,
    [PullRefresh.name]: PullRefresh, [Panel.name]: Panel, [CellGroup.name]: CellGroup, [Cell.name]: Cell,
    [Button.name]: Button, [Popup.name]: Popup, [Icon.name]: Icon, Toast
  },

  data() {
    return {
      activeName: "待盘点",
      searchKey: "",
      refreshing: false,
      resultList: [],
      showList: [],
      showDetails: false,
      listItem: ''
    };
  },

  watch: {
    activeName: {
      handler(val) {
        if (val) {
          this.onLoad();
        }
      },
      immediate: true,
    },
  },

  methods: {
    showItemDetail(item) {
      this.listItem = item
      this.showDetails = true
    },

    onSearch() {
      let that = this
      if (!this.resultList || this.resultList.length == 0) {
        return;
      } else {
        this.showList = [];
        this.resultList.forEach((re) => {
          if (JSON.stringify(re).includes(that.searchKey))
            this.showList.push(re);
        });
      }
    },
    onSearchCancel() {
      this.showList = this.resultList;
    },
    onLoad() {
      let that = this;
      if (this.refreshing) {
        this.resultList = [];
        this.refreshing = false;
      }

      this.$axios
        .get("ipad/mine")
        .then((res) => {
          that.showList = that.resultList = res.filter(
            (item) => item.stock_status == that.activeName
          );
        })
        .catch((res) => {
          Dialog.alert({
            title: "获取iPad资产列表失败",
            message: res,
          }).then(() => {
            this.loading = false;
          });
        });
    },
    gotoStock(id) {
      this.$router.push({
        name: "ipadStock",
        query: { id: id },
      });
    },
    closeDetails() {
      this.showDetails = false;
    },
  },
};
</script>

<style lang="less" scoped>
.list-page {
  background-color: #f7f8fa;

  .item {
    margin: 8px 15px;

    .item_footer {
      text-align: right;

      button {
        width: 60px;
        margin-left: 10px;
      }
    }
  }
}

.detail-container {
  height: 70vh;
  width: 75%;
  margin: 8px 15px;
}
</style>
